import { AutoComplete, Input, Tooltip, Breadcrumb, message, Select, Checkbox } from "antd";
// import { t } from "i18next";
import { ActiveIcon, InactiveIcon, AddIcon } from "../../../asset/icons";
import { EditIcon, DeleteIcon, DetailIcon, SearchIcon, AscRed, DescGrey, CloseIconSearch, PUrgent, PHigh, PMedium, PLow, UnpaidIcon, PaidIcon } from "../../../asset";
import style from "./ShippingCostList.module.css";
import CustomTable from "../../../component/table/CustomTable";
import PrimaryButton from "../../../component/button/PrimaryButton";
import { CustomerListColumn } from "../../../constant/tableConstant";
import DeleteConfirmationModal from "../../../component/modal/DeleteConfirmationModal";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ROUTES } from "../../../constant/routeConstant";
import axios from "axios";
import _, { transform } from "lodash";
import ModalDelete from "../../../component/modal/ModalDelete";
import Delete from "../../../component/modal/ModalDelete";
import CustomPaging from "../../../component/pagination/pagination";
import { GROLOG_ORDER_URL, GROLOG_URL } from "../../../constant/apiConstant";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { onChanged } from "../../../util/Util";
import { LoadingOption, dropdownCustom, selectOption } from "../../../component/select/SelectOption";
import SecondaryButton from "../../../component/button/SecondaryButton";
import ModalStartEndTrip from "../../../component/modal/ModalStartEndTrip";
import ModalSuccessAdd from "../../../component/modal/ModalSuccessAdd";
import ModalFailedDelete from "../../../component/modal/ModalFailedDelete";

const ShippingCostList = (props) => {
  const { t } = useTranslation();
  const [deleteConfirmationModalOpen, setDeleteConfirmationModalOpen] =
    useState(false);
  const [successModalOpen, setSuccessModalOpen] = useState(false);
  const [listData, setListData] = useState([]);
  const location = useLocation()
  const navigate = useNavigate();
  const [showDelete, setShowDelete] = useState(false);
  const [data, setData] = useState([]);
  const [searchRecommendation, setSearchRecommedation] = useState()
  const [listRecommendation, setListRecommendation] = useState([])
  const [sorting, setSorting] = useState("asc");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [initiate, setInitiate] = useState();
  const [filter, setFilter] =useState()
  const [loading, setLoading] = useState(false)
  const [isFilter, setIsfilter] = useState(false);
  const [load, setLoad] = useState(false)
  const [dropdown, setDropdown] = useState([]);
  const [depot, setDepot] = useState();
  const [depotName, setDepotName] = useState();
  const [depot1, setDepot1] = useState();
  const [depotName1, setDepotName1] = useState(); 
  const [pageDepot, setPageDepot] = useState(1)
  const [limitDepot,setLimitDepot] = useState(10)
  const [searchValue, setSearchValue] = useState("")
  const [filterDepot, setFilterDepot] = useState("")
  const [isChecked, setIsChecked] = useState(false);
  // const [listData, setListData] = useState([]);
  const [dataCheck, setDataCheck] = useState([]);
    const [startOpen, setStartOpen] = useState(false);
  const [endOpen, setEndOpen] = useState(false);
  const [trip, setTrip] = useState([]);
  const [listTrip, srtListTrip] = useState([]);
  // const [successModalOpen, setSuccessModalOpen] = useState(false);
  const [failedModalOpen, setFailedModalOpen] = useState(false);
  const [messages, setMessages] = useState("");
  const [isAllPaid, setIsAllPaid] = useState(false)
  const [isAllChecked, setIsAllChecked] = useState(false)
  const dispatch = useDispatch()
  const [dataTemp, setDataTemp] = useState([])
  const [listDataCheck, setListDataCheck] = useState([])
  const { token, client_id, grolog_account_id, userId } = useSelector(
    (state) => state.auth
  );
  let param = `CLIENT_ID=${client_id}&RESOURCE_USER_ID=${userId}&GROLOG_ACCOUNT_ID=${grolog_account_id}`;
  
  const doGet = async (endpoint, tkn, params, dispatch, refresh_token) => {
    
    const api = GROLOG_ORDER_URL
    const url = api + endpoint;
    const method = "GET";
    const headers = { Authorization: token };
    const request = { url, method, headers, params };
    return axios(request);
  };

  const doGetParam = async (endpoint, tkn, params, dispatch, refresh_token) => {
    
    const api = GROLOG_URL
    const url = api + endpoint;
    const method = "GET";
    const headers = { Authorization: token };
    const request = { url, method, headers, params };
    return axios(request);
  };

  const doPost = async (endpoint, tkn, data, dispatch, refresh_token) => {
    // const api = `http://app.sbp:9038/v1/grolog`;
    const api = GROLOG_ORDER_URL;

    const url = api + endpoint;
    const method = "POST";
    const headers = {
      Authorization: token,
    };
    const request = { url, method, headers, data };
    return axios(request);
  };

  const getListDepot = async (page, limit, filter) => {
    let res2 = await doGetParam(
      `/depot-configuration?page=${page}&limit=${limit}${filter ? `&filter=depot_name lk ${filter}` : ""}&${param}`,
      token
    );
    let option =[]
    let list = res2?.data?.payload?.data;
    const currentDepot = [...dropdown];
    console.log("masuk");
    if (list !== null && list.length !== undefined) {
      for (let i = 0; i < list.length; i++) {
        const element = list[i];
        let data = {
          id: element.depot_id,
          value: element.depot_name,
        };
        option.push(data);
      }
      setDropdown(selectOption(currentDepot, option, "value"));
    };
}

  const fetchData = async (data,sort, pages) => {
    setLoad(true)
    console.log("fil", filter);
    console.log("data", data);
    let id = 1;
    let res2 = await doGetParam(
      `/depot-list-filter?page=1&limit=10&${param}`,
      token
    );
    
    if(!res2?.data?.payload?.data){
      setLoad(false)
    }else{
    let res = await doGet(
      `/shipping-cost-payment?page=${pages ? pages :page}&limit=${limit}&order=paid_status ${
        sort ? sort : sorting
      }&filter=depot_id eq ${
        depot ? depot : res2?.data?.payload?.data[0]?.depot_id
      }${filter ? ", id eq " + filter : data ? ", id eq "+ data : ""}&${param}`,
      token)
    let init = await doGet(
      `/shipping-cost-payment/initiate?page=${pages ? pages :page}&limit=${limit}&order=paid_status ${
        sort ? sort : sorting
      }&filter=depot_id eq ${
        depot ? depot : res2?.data?.payload?.data[0]?.depot_id
      }${filter ? ", id eq " + filter : data ? ", id eq "+ data : ""}&${param}`,
      token)

    setListData(res?.data?.payload?.data);
    const isUnpaid = res?.data?.payload?.data?.some((entry) => entry?.payment_status === "Unpaid");
    setIsAllPaid(isUnpaid)
console.log("is there ",isUnpaid);
    let option =[]
    let list = res2?.data?.payload?.data;
    const currentDepot = [...dropdown];
    console.log("masuk");
    if (list !== null && list.length !== undefined) {
      for (let i = 0; i < list.length; i++) {
        const element = list[i];
        let data = {
          id: element.depot_id,
          value: element.depot_name,
        };
        option.push(data);
      }
    }
    
    // else {
    //   setListData(
    //     _.map(res?.data?.payload?.data, (v) => {
    //       return {
    //         ...v,
    //         checked: false,
    //       };
    //     })
    //   );
    //   setDataCheck([]);
    // }
      setDropdown(selectOption(currentDepot, option, "value"));
    
    setDepot1(res2?.data?.payload?.data[0]?.depot_id);
    setDepotName1(res2?.data?.payload?.data[0]?.depot_name);
    setInitiate(init?.data?.payload?.data);
    setListData(res?.data?.payload?.data);
    setLoad(false)
  }
  };
  console.log("listdataall", listData);

  useEffect(() => {
    fetchData();
    onChanged(dispatch, false)
  }, [page,limit,filter, depot,depotName]);

  const onScrollDepot = (event) => {
    let target = event.target;
    if (
      target.scrollHeight - Math.ceil(target.scrollTop) ===
        target.clientHeight || target.scrollHeight - Math.ceil(target.scrollTop) ===
        target.clientHeight+1 &&
      !loading
    ) {
      setLoading(true)
      console.log("sini g");
      setPageDepot(pageDepot+1)
      target.scrollTo(0, target.scrollHeight);
      getListDepot(pageDepot, limitDepot, filterDepot)
    }
  };

  const onChangeDepot = (event) => {
    // setIsAllChecked(false)
    // setPage(1)
    const { value } = event.target;
    const resetPage = 1;
    console.log("value",event.target);
    let filterSearch = value && `${value}`;
    setSearchValue(value)
    let filters = [filterSearch];
    filters = filters.filter(
      (item) => item !== undefined && item !== null && item !== ""
    );
    filters = filters.length !== 0 ? filters.join(", ") : undefined;
    const resetFilter = filters;
    setDropdown([])
    if (value.length >= 2) {
      console.log("value", value);
      setDropdown([])
      setFilterDepot(filters)
      setPageDepot(resetPage)
        setTimeout(() => {
          getListDepot(1,limitDepot,filters)
      }, 256); 
    } else if (!value) {
      setLoading(true)
      setDropdown([])
      setFilterDepot(resetFilter)
      setPageDepot(resetPage)
      getListDepot(1, limitDepot,filters)
    }
  };

  const handleEdit = (id) => {
    navigate(ROUTES.ORDER_REQUEST.EDIT, { state: id });
  };

  const handleAdd = (id) => {
    navigate(ROUTES.ORDER_REQUEST.ADD, { state: depot ? depot : depot1 });
  };

  const handleDetail = (id) => {
    navigate(ROUTES.SHIPPING_COST_PAYMENT.DETAIL, { state: id });
  };

  const setModal = async (data, condition) => {
    await setData(data);
    await setShowDelete(true);
  };
console.log("listdata", listDataCheck);
  const checkAll = (event) => {
    let value = event.target.checked;
    setListDataCheck([])
    if(!isAllChecked){
      setIsAllChecked(true)
    }else if(isAllChecked && listDataCheck.length>0){
      setIsAllChecked(true)
    }else{
      setIsAllChecked(false)
    }

    // if (value) {
    //   setIsAllChecked(true)
    //   setListData(
    //     _.map(listData, (v) => {
    //       if(v.payment_status ==="Unpaid"){
    //       return {
    //         ...v,
    //         checked: true,
    //       };
    //     }else return {
    //       ...v,
    //       checked:false,
    //     };
    //     })
    //   );
    //   setDataCheck(
    //     _.map(listData, (v) => {
    //       if(v.payment_status ==="Unpaid"){
    //       return {
    //         ...v,
    //         checked: true,
    //       };
    //       }else return {
    //         ...v,
    //         checked:false,
    //       };
    //     })
    //   );
    // } else {
    //   setIsAllChecked(false)
    //   setListData(
    //     _.map(listData, (v) => {
    //       return {
    //         ...v,
    //         checked: false,
    //       };
    //     })
    //   );
    //   setDataCheck([]);
    // }
    // // antara !value
    // setIsChecked(value);
  };
  console.log("list isi", listDataCheck);
  const checkOne = (event, result) => {
    let value = event.target.checked;
    console.log("valchk", value, result);
    let listCheckTemp = [...listDataCheck]
    let id = result.id;
    let search = _.find(listDataCheck, (el) => el.id == id);
    let findIndex = _.findIndex(listDataCheck, (el) => el.id == id);
    let data = _.some(dataCheck, search);
    console.log("check data",_.some(listData, (el) => el.id == 5));
    if(_.some(listDataCheck, (el) => el.id === result.id)){
      // _.remove(listDataCheck, search);
      listCheckTemp.splice(findIndex,1)
      setListDataCheck(listCheckTemp)
    }else{
      // setListDataCheck([...listDataCheck], result)
      // listCheckTemp.push(result)
      setListDataCheck([...listDataCheck,result])
    }
    // if (data) {
    //   let checkedFalse = [...listData];
    //   checkedFalse[findIndex] = {
    //     ...checkedFalse[findIndex],
    //     checked: false,
    //   };
    //   _.remove(dataCheck, search);
    //   setIsChecked(false);
    //   setListData(checkedFalse);
    //   // setDataTemp(checkedFalse)
    // } else {
    //   let checkedTrue = [...listData];
    //   checkedTrue[findIndex] = {
    //     ...checkedTrue[findIndex],
    //     checked: true,
    //   };
    //   _.pull(dataCheck, search);
    //   dataCheck.push(checkedTrue[findIndex]);
    //   setListData(checkedTrue);
    //   // setDataTemp(checkedTrue)
    //   if (dataCheck.length === 10) {
    //     setIsChecked(true);
    //   }
    // }
  };

  const dataSource = listData
    ? listData.map((result) => ({
      checkbox: (
        <div className={style.selectOptionContainer}>
          <Checkbox
            onChange={(v) => checkOne(v, result)}
            checked={(_.some(listDataCheck, (el) => el.id === result.id)&&!isAllChecked) || (isAllChecked && result?.payment_status==="Unpaid" && !(_.some(listDataCheck, (el) => el.id === result.id)))}
            disabled={result.payment_status !=="Unpaid"}
            // dataCheck?.map((el) => el.id
            // delivery_associate_id
            // className="mr-2"
            // checked={dataSent?.find(
            //   (permission) => permission === el.code + ":update"
            // )}
            // onChange={(event) =>
            //   onChecked(event, el.code, "update")
            // }
          />
        </div>
      ),
        // si_number: (
        //   <span className="font-roboto text-lg text-[#222222]">
        //     {result?.sales_invoice_number}
        //   </span>
        // ),
        // seller_name: (
        //   <span className="font-roboto text-lg text-[#222222]">
        //     {result?.seller_name}
        //   </span>
        // ),
        order_id: (
          <span className="font-roboto text-lg text-[#222222]">
            {result?.order_id}
          </span>
        ),
        order_group: (
          <span className="font-roboto text-lg text-[#222222]">
            {result?.order_number}
            </span>
        ),
        shipping_cost: (
          <span className="font-roboto text-lg text-[#222222] flex justify-between">
            {/* <div className="ju"> */}
              <div>Rp.</div>
              <div>
            {result?.price}</div>
            {/* </div> */}
          </span>
        ),
        order_number: (
          <span className="font-roboto text-lg text-[#222222]">
            {result?.order_number}
          </span>
        ),
        // priority: (
        //   <span className="font-roboto text-lg text-[#222222]">
        //     {/* {result?.priority} */}
        //     <img src={result?.priority === 1 ?PUrgent: result?.priority===2 ? PHigh: result?.priority===3?PMedium:PLow} alt="prio"/>
        //   </span>
        // ),
        status: (
          <span className="font-roboto text-lg text-[#222222]">
            <img src={result?.payment_status==="Unpaid" ? UnpaidIcon : PaidIcon} alt="pay"/>
          
          </span>
        ),
        action: (
          <div className="flex gap-[26px]">
            {/* <Tooltip title={t("USER:EDIT_TOOLTIP")} color="#CF0000">
              <button onClick={() => handleEdit(result?.id)}>
                <img src={EditIcon} alt="edit" />
              </button>
            </Tooltip> */}
            {/* <Tooltip title={t("Delete")} color="#CF0000">
              <button onClick={result?.status === "New" ? () => setModal(result) : ""}>
                <img src={DeleteIcon} alt="del" />
              </button>
            </Tooltip> */}

            <Tooltip title={t("USER:DETAIL_TOOLTIP")} color="#CF0000">
              <button
                // onClick={() => handleDelete(result?.id, result?.updated_at)}
                onClick={() => handleDetail(result?.id)}
              >
                <img src={DetailIcon} alt="det" />
              </button>
            </Tooltip>
          </div>
        ),
      }))
    : null;

    const doSort = async (sort) => {
      setSorting(sort);
    
      if (sort) {
      setSorting(sort);
        // fetchData();
        
      fetchData("", sort);
        // this.setState({ loading: true });
        // await this.setState(
        //   {
        //     orderby: `${code+" "+sort}`,
        //     pageProductivitySalesman:1,
        //   }
        // )
      }
    };

  const ListColumn = [
    {
      width: 50,
      title: <div className={style.selectOptionContainer}>
      <Checkbox
        onChange={(v) => checkAll(v)}
        disabled={!isAllPaid}
        checked={(isAllChecked && listDataCheck.length===0)}
        // disabled={result.payment_status !=="Unpaid"}
        // // dataCheck?.map((el) => el.id
        // // delivery_associate_id
        // // className="mr-2"
        // // checked={dataSent?.find(
        // //   (permission) => permission === el.code + ":update"
        // // )}
        // // onChange={(event) =>
        // //   onChecked(event, el.code, "update")
        // // }
      />
    </div>,
      dataIndex: "checkbox",
      key: "checkbox",
      render: (checkbox) => <span>{checkbox}</span>,
    },
    // {
    //   title: (
    //     <span className="font-roboto text-lg text-[#222222] font-medium">
    //     {t("SI Number")}
    //   </span>
    //   ),
    //   dataIndex: "si_number",
    //   key: "si_number",
    //   render: (si_number) => <span>{si_number}</span>,
    // },

    // {
    //   title: (
    //     <span className="font-roboto text-lg text-[#222222] font-medium">
    //       {t("Seller Name")}
    //     </span>
    //   ),
    //   dataIndex: "seller_name",
    //   key: "seller_name",
    //   render: (seller_name) => <span>{seller_name}</span>,
    // },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("Order ID")}
        </span>
      ),
      dataIndex: "order_id",
      key: "order_id",
      render: (order_id) => <span>{order_id}</span>,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("Order Group")}
        </span>
      ),
      dataIndex: "order_group",
      key: "order_group",
      render: (order_group) => <span>{order_group}</span>,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("Shipping Cost")}
        </span>
      ),
      dataIndex: "shipping_cost",
      key: "shipping_cost",
      render: (shipping_cost) => <span>{shipping_cost}</span>,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("Order Number")}
        </span>
      ),
      dataIndex: "order_number",
      key: "order_number",
      render: (order_number) => <span>{order_number}</span>,
    },
    // {
    //   title: (
    //     <span className="font-roboto text-lg text-[#222222] font-medium">
    //       {t("Priority")}
    //     </span>
    //   ),
    //   dataIndex: "priority",
    //   key: "priority",
    //   render: (priority) => <span>{priority}</span>,
    // },
    {
      title: (
        <div style={{ display: "flex", width: "auto" }}>
        <div style={{ width: "60%" }}>
          <span className="font-roboto text-lg text-[#222222] font-medium">
            {t("Paid Status")}
          </span>
        </div>
        <div style={{ width: "3%", marginLeft: "2px", marginTop: "3px" }}>
          <div className={style.SortArea}>
          <Tooltip title={t("Asc")} color="#CF0000">
                <img
                  src={sorting === "asc" ? AscRed : DescGrey}
                  alt="asc"
                  className={sorting === "asc" ? "w-full cursor-pointer":"rotate-180 w-full cursor-pointer"}
                  onClick={() => {
                    doSort("asc");
                  }}
                  // disabled={sorting==="asc"}
                />
              </Tooltip>

              <Tooltip title={t("Desc")} color="#CF0000">
                <img
                  src={sorting === "asc" ? DescGrey : AscRed}
                  alt="desc"
                  className={sorting === "asc" ? "w-full cursor-pointer":"rotate-180 w-full cursor-pointer"}
                  onClick={() => {
                    doSort("desc");
                  }}
                  
                  // disabled={sorting==="desc"}
                />
              </Tooltip>
          </div>
        </div>
      </div>
      ),
      dataIndex: "status",
      key: "status",
      render: (status) => <span>{status}</span>,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("USER:ACTION_FIELD")}
        </span>
      ),
      dataIndex: "action",
      key: "action",
      render: (action) => action,
    },
  ];
  const handlePagination = (a,b)=>{
    console.log(a,b);
    if (a && b) {
      setPage(a)
      setLimit(b)
    } else {
     
    }
  };

  const fetchRecommendation = async (
    page,
    limit,
    filters,
    mapping_principal_id
  ) => {
    if (filters.length >= 1) {
    let res = await doGet(`/shipping-cost-payment/search?page=1&limit=10&filter=depot_id eq ${depot ? depot : depot1}, search_scp lk ${filters}&${param}`, token);
    setListRecommendation(res?.data?.payload?.data);

    }
  };

  const handleChange = (value, id) => {
    setIsAllChecked(false)
    setListDataCheck([])
    setPage(1)
    setDepot(value);
    setDepotName(value);
    fetchData();
  };

  const onSearchRecommendation = async (value) => {
    setSearchRecommedation(value)
    setIsfilter(true)
    if (value?.length >=3) {
      setSearchRecommedation(value)
      await fetchRecommendation(1,10,value)
    } else {
      
    // setFilter(null);
    setInitiate([])
    // setSearchRecommedation("");
    // setListRecommendation([]);
    // fetchData("",1);
    }
  };

  const onSelectRecommendation =(data) => {
    console.log("data", data);
    setPage(1)
    setFilter(data)
    fetchData(data, sorting, 1)
    setSearchRecommedation(listRecommendation.find(item => item.id == data).value)
    setIsfilter(false)
    setListRecommendation("")
  };

  const onClearRecommendation = (e) => {
    setIsfilter(false);
    setFilter(null);
    setInitiate([])
    setSearchRecommedation("");
    setListRecommendation("");
    fetchData("",sorting,1);
  };

  console.log("listrec", listRecommendation);

  // const options =
  //     listRecommendation &&
  //     listRecommendation?.map((item) => ({
  //       value: item.value,
  //       label: item.value,
  //     }));
  const onStart = async () => {
    let cek = [];
    // let id=
    dataCheck?.map((el) => {
      cek.push({
        id: el.id,
        updated_at: el.updated_at,
      });
    });
    let list_trip = { list_id: listDataCheck, is_check_all:isAllChecked };

    try {
      let tkn = token;
      let res = await doPost(`/shipping-cost-payment/paid?${param}`, tkn, list_trip);
      // setSuccessModalOpen(true);
      // message.success(_.startCase("Success Start Trip"));
      setMessages("Success Paid");
      setDataCheck([]);
      setSuccessModalOpen(true);
      setStartOpen(false);
      setIsAllChecked(false)
      setListDataCheck([])
      setPage(1)
    } catch (err) {
      if (
        err.response.data.payload.message ===
        "Data with this Additional Name is already used by other, cant process this action"
      ) {
        // setErr(err.response.data.payload.message)
      } else {
        // message.error(_.startCase(err.response.data.payload.message));
        setMessages(err.response.data.payload.message);
        setFailedModalOpen(true);
        setStartOpen(false);
      }
    }
  };

  const onEnd = async () => {
    let cek = [];
    console.log("isi datacheck", dataCheck);
    // let id=
    dataCheck?.map((el) => {
      cek.push({
        id: el.order_id,
        updated_at: el.updated_at,
      });
    });
    let list_trip = { list_gromart_order: cek };
console.log("list trip", list_trip);
    try {
      let tkn = token;
      let res = await doPost(`/gromart-order/reject?${param}`, tkn, list_trip);
      // setSuccessModalOpen(true);
      setMessages("Success Reject");
      setDataCheck([]);
      setSuccessModalOpen(true);
      setEndOpen(false);
    } catch (err) {
      if (
        err.response.data.payload.message ===
        "Data with this Additional Name is already used by other, cant process this action"
      ) {
        // setErr(err.response.data.payload.message)
      } else {
        // message.error(_.startCase(err.response.data.payload.message));
        setMessages(err.response.data.payload.message);
        setFailedModalOpen(true);
        setEndOpen(false);
      }
    }
  };

  const actModal = () => {
    setSuccessModalOpen(false);
    setFailedModalOpen(false);
    setStartOpen(false);
    setEndOpen(false);
    setMessages("");
    setDataCheck([]);
    fetchData();
  };
  
  return (
    <>
          <ModalStartEndTrip
        visible={startOpen}
        styles={" w-[200px] ml-[-20px]"}
        message={`Are you sure want to change to paid?`}
        message2={"If you have changed, the status cant be edited again"}
        titles="Change"
        widthPaid="499px"
        title2="Change Payment Status?"
        isPaid={true}
        onClick={() => onStart()}
        action={() => setStartOpen(false)}
      />
      {/* <ModalStartEndTrip
        visible={endOpen}
        styles={" w-[200px] ml-[-20px]"}
        message={`Are you sure want to approve`}
        title="Reject Order"
        onClick={() => onEnd()}
        action={() => setEndOpen(false)}
      /> */}
      <ModalSuccessAdd
        show={successModalOpen}
        action={() => actModal()}
        closable={false}
        width={280}
        className={style.deleteModal}
        okText="Ok"
        title="Success"
        description={messages}
      />
      <ModalFailedDelete
        show={failedModalOpen}
        action={() => actModal()}
        closable={false}
        width={414}
        className={style.deleteModal}
        okText="Ok"
        title="Data Cant be added"
        description={messages}
      />
      <Delete
        data={data.updated_at}
        id={data.order_id}
        delete={showDelete}
        title={data?.customer_name}
        url={"order"}
        action={() => setShowDelete(false)}
        refresh={()=>fetchData()}
        token={token}
        param={param}
      />
      <div className="p-[24px] flex flex-col gap-[24px]">
        <div>
          <Breadcrumb separator=">">
            <Breadcrumb.Item>Order</Breadcrumb.Item>
            <Breadcrumb.Item>Shipping Cost Payment</Breadcrumb.Item>
          </Breadcrumb>
        </div>

        <h1 className="font-sans-bold mt-[-15px] text-2xl" id="title">
          {t("Shipping Cost Payment")}
        </h1>

        <div
          className={
            style.headerContainer + " flex justify-between items-center"
          }
        >
          <div className="flex">
         <AutoComplete
                 options={ listRecommendation &&
                  listRecommendation?.map((item) => ({
                    value: item.id,
                    label: item.value,
                  }))}
                 value={searchRecommendation}
                 onChange={(value) => onSearchRecommendation(value)}
                 onSelect={(value) => onSelectRecommendation(value)}
               >
              <Input
                placeholder={t("Search SI Number or Seller Name")}
                className="w-[350px] h-[47px]"
                height={47}
                width={350}
                suffix={<img 
                  src={filter? CloseIconSearch : SearchIcon} 
                  alt="search" 
                  onClick={filter? () => onClearRecommendation() : null}
                />}
                
                // options={options}
                value={searchRecommendation}
                // onChange={(value) => onSearchRecommendation(value)}
              />
            </AutoComplete>
            <Select
              className={style.selectContainer + " ml-3 w-[200px]"}
              // options={dropdown}
              value={depotName ? depotName : depotName1}
              onChange={(id, val) => handleChange(id, val)}
              onPopupScroll={(e) => onScrollDepot(e)}
              dropdownRender={(menu) =>
                dropdownCustom(
                  menu,
                  (value) => onChangeDepot(value),
                  searchValue
                )
              }
              >
              {!loading
                  ? dropdown
                  : [...dropdown, LoadingOption()]}
              </Select>
              <PrimaryButton
              text={t("Paid")}
              styles="ml-3 mr-3"
              disabled={!listDataCheck?.length && !isAllChecked}
              action={() => setStartOpen(true)}
            />
            {/* <SecondaryButton
              text={t("Reject")}
              disabled={!dataCheck?.length}
              action={() => setEndOpen(true)}
              // action={() => setPage(1)}
            /> */}
            </div>

          {/* <Link to={ROUTES.ORDER_REQUEST.ADD}> */}
            {/* <PrimaryButton
              text={t("Add Order Request")}
              prefixIcon={<AddIcon />}
              action={() => handleAdd()}/> */}
          {/* </Link> */}
        </div>

        {
  !load ?
        <div className={style.tableContainer}>
          <CustomTable columns={ListColumn} data={dataSource} />
          <div className={style.containerPagination + " mt-[-45px]"}>
            <CustomPaging
              idLimit="ddlrowsperpagemustselllist"
              idPagination="btnpaginationmustselllist"
              size="small"
              current={page}
              defaultCurrent={page}
              pageSize={limit}
              total={initiate && initiate?.count_data}
              pageSizeOptions={initiate && initiate?.valid_limit}
              onShowSizeChange={() => handlePagination()}
              handlePaging={(a,b) => handlePagination(a,b)}
              title={t("COMMON:ROW_PAGE")}
            />
          </div>
        </div>
        : "...loading"}
      </div>
    </>
  );
};

export default ShippingCostList;
